<div class="container-fluid">
  <div class="row">
    <div class="col-xl-12">
      <h1 class="page-hd">Uploaded List</h1>
      <div class="content-wrap">
        <form [formGroup]="uploadDocAssociateForm">
          <div class="filter-wrap">
            <div class="form-group" formGroupName="myCheckboxGroup">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="page-subhd">Select from the filters below to view the list</h3>
                </div>
                <!-- <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="firstName" class="form-label">Student Name </label>
                    <input type="text" placeholder="Enter your Student Name" [(ngModel)]="associateDocList.firstName"
                      class="form-control form-input" id="firstName" formControlName="firstName"
                      [ngClass]="{'is-invalid': submitted && f.firstName.errors }" />
                    <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                      <div *ngIf="f.firstName.errors.required">Student Name is required</div>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="lastName" class="form-label">Student Surname</label>
                    <input type="text" class="form-control form-input" id="lastName" formControlName="lastName"
                      [(ngModel)]="associateDocList.lastName" placeholder="Enter Student Surname">
                    <div class="invalid-feedback">
                      <div>Student Surname is required</div>
                    </div>
                  </div>
                </div> -->
                <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="enrollmentNo" class="form-label">Seat No.</label>
                    <input type="text" class="form-control form-input" id="enrollmentNo" formControlName="enrollmentNo"
                      [(ngModel)]="associateDocList.enrollmentNo" placeholder="Enter Seat No.">
                    <div class="invalid-feedback">
                      <div>Seat Number is required</div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="college" class="form-label">College Name</label>
                    <select formControlName="collegeName" class="form-control form-input" id="collegeNameId"
                      [(ngModel)]="associateDocList.collegeId">
                      <option value="" disabled selected> Please select College </option>
                      <option *ngFor="let college of collegeDropDown" [ngValue]="college.id">
                        {{college.collegeName}}</option>
                    </select>
                  </div>
                </div> -->
                <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="stream" class="form-label">Stream</label>
                    <select formControlName="stream" class="form-control form-input" id="streamid"
                      [(ngModel)]="associateDocList.streamId" placeholder="Select Your Stream"
                      (change)='getBranAndStream()'>
                      <option value="" disabled selected> Please select Stream </option>
                      <option *ngFor="let stream of streamDropDown" [ngValue]="stream.id">
                        {{stream.streamName}}</option>
                    </select>
                  </div>
                </div>
                <!-- <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="branch" class="form-label">Branch</label>
                    <select formControlName="branch" class="form-control form-input" id="branchid"
                      [attr.disabled]="!associateDocList.streamId ? '' : null" [(ngModel)]="associateDocList.branchId"
                      placeholder="Select Your Branch">
                      <option value="" disabled selected> Please select Branch </option>
                      <option *ngFor="let branch of branchDropDown" [ngValue]="branch.id">
                        {{branch.branchName}}</option>
                    </select>
                  </div>
                </div> -->
                <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="semester" class="form-label">Semester</label>
                    <select formControlName="semester" class="form-control form-input" id="semesterid"
                      style="color:rgba(0, 0, 0, 0.54) !important;"
                      [attr.disabled]="!associateDocList.streamId ? '' : null" [(ngModel)]="associateDocList.semId"
                      placeholder="Select Your Semester">
                      <option value="" disabled selected> Please select Semester </option>
                      <option *ngFor="let semester of semesterDropDown" [ngValue]="semester.id">
                        {{semester.semester}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group input-group-lg">
                    <label for="passingYear" class="form-label">Year of Passing</label>
                    <!-- <select formControlName="passingYear" class="form-control form-input" 
                     >
                      <option value="" disabled selected> Please select Year Of Passing </option>
                      <option *ngFor="let year of YearOfPassDropDown" [ngValue]="year.id">
                        {{year.yearOfPassing}}</option>
                    </select> -->

                    <mat-form-field style="display: block !important;" id="matformfield">
                      <input matInput [matDatepicker]="dp" placeholder="Select Month and Year" id="yearofpassid"
                        formControlName="passingYear" [matDatepickerFilter]=dateFilter autocomplete="off" >
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle >
                      <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)" 
                        (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
                      </mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="invalid-feedback2"
                *ngIf="uploadDocAssociateForm.controls['myCheckboxGroup'].errors && uploadDocAssociateForm.controls['myCheckboxGroup'].errors">
                At least 3 input value is required to search</div>
              <div class="col-md-12">
                <button class="page-btn bg-theme pull-right mt-1"
                  [disabled]="uploadDocAssociateForm.controls['myCheckboxGroup'].errors && uploadDocAssociateForm.controls['myCheckboxGroup'].errors"
                  (click)="searchData($event)">Search</button>
              </div>
            </div>
          </div>
          <div class="table-responsive mt-5">
            <table class="ui celled table hover" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <!-- <th>Student Name</th>
                  <th>Student Surname</th> -->
                  <th>Seat No.</th>
                  <th>Stream</th>
                  <!-- <th>Branch</th> -->
                  <th>Semester</th>
                  <!-- <th>Month Of Passing</th> -->
                  <th>Year of passing</th>
                  <!-- <th>College Name</th> -->
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of request">
                  <!-- <td>{{data.firstName}}</td>
                  <td>{{data.lastName}}</td> -->
                  <td>{{data.enrollmentNo}}</td>
                  <td>{{data.stream}}</td>
                  <!-- <td>{{data.branch_nm}}</td> -->
                  <td>{{data.semester}}</td>
                  <td>{{data.monthOfPassing}}/{{data.passingYear}}</td>
                  <!-- <td>{{data.collegeName}}</td> -->
                  <td>
                    <!-- <button class='action-btn bg-theme' data-toggle="modal" data-target="#viewModal"
                      (click)="openModal(data.id,data.originalDOCuploadfilePath)">View123  </button>
                    <button class="action-btn bg-theme" data-dismiss="modal"
                      (click)="openModal(data.id,data.originalDOCuploadfilePath)">View</button> -->
                      <button class="action-btn bg-theme" data-dismiss="modal"
                      (click)="openModal(data.id,data.originalDOCuploadfilePath)">View</button>
                    <button class='action-btn2' (click)="passData(32,data)">Edit</button>
                    <button class='action-btn3' (click)="delete(data.id)">Delete</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Uploaded Document</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <p class="doc-txt">Uploaded file</p>
            <!-- <img [src]="upload_doc_path" class="doc-img"> -->

            <div *ngIf="isUPdf">
              <div class="ng-star-inserted22">
                <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
              </div>
              <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isUImage">
              <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" >
            </div>

            <!-- <img src="../../assets/images/certificate.jpg" alt="Certificate" class="doc-img"> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #showModalBoxImage let-modal>
  <div class="modal-content">
    <div class="modal-header bg-theme">
      <h5 class="modal-title" id="viewModalLabel">Uploaded Document</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p class="doc-txt">Uploaded file</p>

          <div *ngIf="isUPdf">
            <div class="ng-star-inserted22">
              <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
            </div>
            <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
          </div>
          <div *ngIf="isUImage">
          <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(1)" loading="lazy">
        </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>


<ng-template #showModalDeleteBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
        <span class="icon-wrap2">
          <img src="assets/images/delete.png" class="fa-icon-modal" alt="img">
        </span>
      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Alert</h3>
          <p class="reset-hd2">Are you sure you want to delete?</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="deleteData()">Yes</button>
        </div>
        <div class="col-md-6">
          <button class="approve-modal-btn3 mr-auto" data-dismiss="modal" (click)="refresh()">No</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
        <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Success</h3>
          <p class="reset-hd2">{{delMessage}}</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
  </div>
</ng-template>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
<!-- <ng-image-fullscreen-view
  [images]="imageObject"
  [imageIndex]="selectedImageIndex"
  [show]="showFlag"
  (close)="closeEventHandler()">
  </ng-image-fullscreen-view> -->